/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

if (typeof window.jQuery !== "undefined") {
  jQuery.cookie = function (b, j, m) { if (typeof j != "undefined") { m = m || {}; if (j === null) { j = ""; m.expires = -1 } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) { var f; if (typeof m.expires == "number") { f = new Date(); f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000)) } else { f = m.expires } e = "; expires=" + f.toUTCString() } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : ""; document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("") } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d } };
}

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.Products = (function () {
    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        layout: 'slider',
        swipe: true,
        media: 'adapt',
        onComplete: null
    };
    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;
    var shownSection = 0;
    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function (recentlyViewed) {
            if (typeof window.jQuery !== "undefined" && typeof jQuery.cookie === "function") {
                jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
            }
        },
        read: function () {
            var recentlyViewed = [];
            if (typeof window.jQuery !== "undefined" && typeof jQuery.cookie === "function") {
                var cookieValue = jQuery.cookie(this.name);
                if (cookieValue !== null && cookieValue !== undefined) {
                    recentlyViewed = cookieValue.split(' ');
                }
            }
            return recentlyViewed;
        },
        destroy: function () {
            if (typeof window.jQuery !== "undefined" && typeof jQuery.cookie === "function") {
                jQuery.cookie(this.name, null, this.configuration);
            }
        },
        remove: function (productHandle) {
            var recentlyViewed = this.read();
            var position = recentlyViewed.indexOf(productHandle);
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    };

    var finalize = function () {
        var items = wrapper.find('.item')
        if (items.length <= 2) $('#recently-viewed-products-list').addClass('center');

        $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');

        wrapper.show();
        // If we have a callback.
        if (config.onComplete) {
            try {
                config.onComplete();
            } catch (error) { }
        }
    };

    var moveAlong = function (wrapperP) {
        if (productHandleQueue.length && shown < config.howManyToShow) {
            var url = window.routes.root + '/products/' + productHandleQueue[shown] + '?view=ajax_recently_viewed';

            jQuery.ajax({
                type: 'get',
                url: url,
                cache: false,
                success: function (product) {
                    wrapperP.append(product);
                    shown++;
                    moveAlong(wrapperP);
                },
                error: function () {
                    cookie.remove(productHandleQueue[shown]);
                    shown++;
                    moveAlong(wrapperP);
                }
            });
        } else {
            finalize();
        }
    };

    var parseBoolean = function (value, fallback) {
        if (value === true || value === 'true' || value === 1 || value === '1') return true;
        if (value === false || value === 'false' || value === 0 || value === '0') return false;
        return fallback;
    };

    var initSectionSlider = function (wrapperS) {
        if (config.layout !== 'slider' || !wrapperS.length) return;

        var mobileMedia = window.matchMedia('(max-width: 767px)');
        var sliderElement = wrapperS.get(0);

        if (!sliderElement.reventRecentlyViewedMedia) {
            sliderElement.reventRecentlyViewedMedia = mobileMedia;

            var refreshRecentlyViewedLayout = function () {
                initSectionSlider(wrapperS);
            };

            if (mobileMedia.addEventListener) {
                mobileMedia.addEventListener('change', refreshRecentlyViewedLayout);
            } else {
                mobileMedia.addListener(refreshRecentlyViewedLayout);
            }
        }

        if (mobileMedia.matches) {
            if (wrapperS.hasClass('slick-initialized')) {
                wrapperS.slick('unslick');
            }

            wrapperS.addClass('revent-mobile-recent-grid');

            var mobileControls = wrapperS.next('.revent-recently-more');
            var productCount = wrapperS.children('.product').length;

            if (productCount > 4 && !mobileControls.length) {
                mobileControls = $('<div class="revent-recently-more"><button type="button" aria-expanded="false">Show more</button></div>');
                mobileControls.insertAfter(wrapperS);

                mobileControls.find('button').on('click', function () {
                    var isExpanded = wrapperS.toggleClass('is-expanded').hasClass('is-expanded');

                    $(this)
                        .attr('aria-expanded', isExpanded ? 'true' : 'false')
                        .text(isExpanded ? 'Show fewer' : 'Show more');
                });
            } else if (productCount <= 4 && mobileControls.length) {
                mobileControls.remove();
            }

            return;
        }

        wrapperS.removeClass('revent-mobile-recent-grid is-expanded');
        wrapperS.next('.revent-recently-more').remove();

        if (wrapperS.hasClass('slick-initialized')) return;

        var itemToShow = parseInt(wrapperS.data('item-to-show'), 10) || 5;
        var itemDots = parseBoolean(wrapperS.data('item-dots'), false);
        var itemDotsMb = parseBoolean(wrapperS.data('item-dots-mb'), true);
        var itemArrows = parseBoolean(wrapperS.data('item-arrows'), true);
        var itemArrowsMb = parseBoolean(wrapperS.data('item-arrows-mb'), false);

        wrapperS.slick({
            mobileFirst: true,
            adaptiveHeight: false,
            vertical: false,
            infinite: false,
            slidesToShow: Math.min(3, itemToShow),
            slidesToScroll: Math.min(3, itemToShow),
            arrows: itemArrowsMb,
            dots: itemDotsMb,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: Math.min(4, itemToShow),
                        slidesToScroll: Math.min(4, itemToShow),
                        arrows: itemArrows,
                        dots: itemDots
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: itemToShow,
                        slidesToScroll: Math.min(itemToShow, 5),
                        arrows: itemArrows,
                        dots: itemDots
                    }
                }
            ]
        });
    };

    var cachedSectionProduct = function (handle) {
        var key = 'revent-v27-recent-' + handle;

        try {
            var cached = sessionStorage.getItem(key);
            if (cached) return Promise.resolve(cached);
        } catch (error) {
            // Session storage can be unavailable in private browsing.
        }

        var url = window.routes.root + '/products/' + handle + '?view=ajax_section_recently_viewed';

        return fetch(url, {
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' }
        }).then(function (response) {
            if (!response.ok) throw new Error('Unable to load recently viewed product.');
            return response.text();
        }).then(function (html) {
            try {
                sessionStorage.setItem(key, html);
            } catch (error) {
                // Ignore storage quota and privacy errors.
            }
            return html;
        });
    };

    var doAlong = function (wrapperS) {
        var recentlyViewed = wrapperS.parents('.halo-recently-viewed-block');
        var handles = productHandleQueue.slice(0, config.howManyToShow);

        recentlyViewed.addClass('is-loading').removeClass('is-ready');

        if (!handles.length) {
            recentlyViewed.hide();
            return;
        }

        shownSection = 0;

        Promise.allSettled(handles.map(function (handle, index) {
            return cachedSectionProduct(handle).then(function (html) {
                return { index: index, html: html };
            }).catch(function () {
                cookie.remove(handle);
                return null;
            });
        })).then(function (results) {
            var products = results
                .map(function (result) {
                    return result.status === 'fulfilled' ? result.value : null;
                })
                .filter(Boolean)
                .sort(function (left, right) {
                    return left.index - right.index;
                });

            wrapperS.find('.product-item--loadingNoInfo').parents('.product').remove();
            wrapperS.empty();

            products.forEach(function (product) {
                wrapperS.append(product.html);
            });

            shownSection = products.length;
            recentlyViewed.find('.revent-recently-loader').remove();

            if (!shownSection || wrapperS.find('.product-item').length === 0) {
                recentlyViewed.hide();
                return;
            }

            initSectionSlider(wrapperS);

            window.requestAnimationFrame(function () {
                recentlyViewed.removeClass('is-loading').addClass('is-ready');
                wrapperS.addClass('recently-viewed-loaded');

                if (window.sharedFunctions && window.sharedFunctions.setLocalStorageProductForWishlist) {
                    window.sharedFunctions.setLocalStorageProductForWishlist();
                }

                if (config.onComplete) {
                    try {
                        config.onComplete();
                    } catch (error) {
                        console.warn('Recently viewed completion callback failed:', error);
                    }
                }
            });
        });
    };

    return {
        resizeImage: function (src, size) {
            if (size == null) {
                return src;
            }

            if (size == 'master') {
                return src.replace(/http(s)?:/, "");
            }

            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
            } else {
                return null;
            }
        },

        showRecentlyViewed: function (params) {
            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            productHandleQueue = cookie.read();

            // Template and element where to insert.
            template = config.templateId;
            wrapper = jQuery('#' + config.wrapperId);

            // How many products to show.
            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

            // If we have any to show.
            if (config.howManyToShow && wrapper.length) {
                // Getting each product with an Ajax call and rendering it on the page.
                if (template == 'recently-viewed-product-popup') {
                    const wrapperP = wrapper;
                    moveAlong(wrapperP);
                } else {
                    const wrapperS = wrapper;
                    doAlong(wrapperS);
                }
            }
        },

        getConfig: function () {
            return config;
        },

        clearList: function () {
            cookie.destroy();
        },

        recordRecentlyViewed: function (params) {
            var params = params || {};

            // Update defaults.
            if (typeof window.jQuery !== "undefined" && jQuery.extend) {
                jQuery.extend(config, params);
            } else {
                Object.assign(config, params);
            }

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1) {
                // What is the product handle on this page.
                var splitted = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
                if (splitted == null) {
                    var productHandle = decodeURIComponent(window.location.pathname.split('/products/')[1]);
                } else {
                    var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                }
                // In what position is that product in memory.
                var position = jQuery.inArray(productHandle, recentlyViewed);
                // If not in memory.
                if (position === -1) {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                } else {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);
            }
        }
    };
})();